<ng-container *ngIf="!loading">
  <ng-container *ngIf="!hasError">
    <app-enroll-msg [matchInfo]="matchInfo" [enrollUrl]="url" *ngIf="!isEnrolled"></app-enroll-msg>
    <app-account-details [accountInfo]="accountInfo" [portalUrl]="url" *ngIf="isEnrolled"></app-account-details>
  </ng-container>
  <app-error *ngIf="hasError"></app-error>
</ng-container>
<app-loading-dots color="#008eff" *ngIf="loading"></app-loading-dots>
